<button (click)="onScrollToTop()" mat-raised-button class="MatBtn goToTopBgColor" aria-label="Scroll to top">
  <i class="fas fa-arrow-up goToTop"></i>
  <span class="sr-only">Scroll to top</span>
</button>